module.exports = __webpack_public_path__ + "static/media/bq-user-icon.2e4c61b3.svg";